<template>
	<div class="container page">
		<van-nav-bar :title="$t('setting.language')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="items">
			<div class="item van-hairline--bottom" @click="changeLang(item.value, $event)" v-for="item in langList"
				:key="item.id">
				<div class="flex_center">
					<div class="info">{{item.name}}</div>
				</div>
				<div v-if="lang == item.value">✓</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Language",
		data() {
			return {
				lang: this.$i18n.locale || "vi",
				langList: []
			};
		},
		created() {
			this.getBaseInfo()
		},
		mounted() {},
		methods: {
			back() {
				return window.history.back();
			},
			getBaseInfo() {
				this.$http({
					method: 'get',
					url: 'base_info'
				}).then(res => {
					this.langList = res.data.langList
					// this.lang = res.data.defaultLang
					// console.log(res.data, '5555')
				})
			},
			changeLang(lang) {
				console.log(lang)
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			},
		}

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: linear-gradient(90deg, #f905e5, #e6c3a1);
	}

	.container .items {
		background-color: #fff;
		font-size: 30px;
		color: #000;
		padding: 25px;
	}

	.container .items .item {
		padding: 20px 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-bottom-width: 10px;
	}

	.container .items .van-hairline--bottom::after {
		border-bottom-width: 3px;
		padding: 10px 0;
	}

	.container .sign-out {
		margin: 500px 20px 0;
		height: 100px;
		line-height: 100px;
		border-radius: 50px;
		color: #fff;
		font-size: 40px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(270deg, #e6c3a1, #7e5678);
	}

	.container .item .desc {
		font-size: 30px;
		font-weight: 700;
		color: #979799;
	}

	.container .item .right {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.flex_center {
		display: flex;
		align-items: center;
	}

	.flex_center img {
		width: 60px;
		height: 60px;
		margin-right: 20px;
	}
</style>